export default __webpack_public_path__ + "static/media/codebot_head_blink.7d79484e.svg";